import { announceLocalStorageChange } from "@/src/hooks/useLocalStorageState";

export const DEFAULT_MANUSCRIPT_MARGIN = "comfortable";
export const MANUSCRIPT_MARGIN_STORAGE_KEY = "manuscriptMargin";
export const MANUSCRIPT_MARGIN_OPTIONS = [
  { value: "minimal", label: "Minimal margins" },
  { value: "narrow", label: "Narrow margins" },
  { value: "comfortable", label: "Comfortable margins" },
  { value: "wide", label: "Wide margins" },
  { value: "extra-wide", label: "Extra-wide margins" },
];

export function isManuscriptMargin(value) {
  return MANUSCRIPT_MARGIN_OPTIONS.some((option) => option.value === value);
}

export function loadManuscriptMargin() {
  try {
    const value = localStorage.getItem(MANUSCRIPT_MARGIN_STORAGE_KEY);
    return isManuscriptMargin(value) ? value : DEFAULT_MANUSCRIPT_MARGIN;
  } catch {
    return DEFAULT_MANUSCRIPT_MARGIN;
  }
}

export function saveManuscriptMargin(value) {
  if (!isManuscriptMargin(value)) return;

  try {
    localStorage.setItem(MANUSCRIPT_MARGIN_STORAGE_KEY, value);
    announceLocalStorageChange(MANUSCRIPT_MARGIN_STORAGE_KEY);
  } catch {
    // The in-memory preference still applies when browser storage is unavailable.
  }
}
